{
  "fr": {
    "employee": {
      "actions": {
        "accessProjects": "Gérer l'accès aux projets",
        "cancel": "Annuler",
        "changeProfilePicture": "Changer l'Image du Profil",
        "download": "Télécharger",
        "new": "Collègue",
        "profilePictureFormat": "Doit être image carrée, au moins 300x300px",
        "save": "Enregistrer",
        "searchEmployee": "Rechercher Collègue",
        "sendinvitation": "Créer et envoyer une invitation",
        "submit": "Enregistrer",
        "undoChanges": "Annuler"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Une fois par jour (vers midi)",
          "hourly": "Toutes les heures",
          "twice_daily": "Deux fois par jour (matin/midi)",
          "weekly": "Une fois par semaine (lundi midi)"
        },
        "first_name": "Prénom",
        "language": "Langue",
        "last_name": "Nom",
        "phone_landline": "Numéro fixe",
        "phone_mobile": "Numéro de portable",
        "profession": "Fonction de Travail",
        "role": "Droits d'accès",
        "signature_html": "Signature des conversations",
        "status": "Status",
        "title": "Titre"
      },
      "billing": {
        "contact_us": "Contactez-nous",
        "contact_us_message": "Bonjour, je souhaite modifier le forfait de {client_name}.",
        "gigabytes": "{amount} Go",
        "in_use": "/ {total} utilisés",
        "manage_members": "Gérer les membres",
        "package": "Forfait",
        "package_help_mup": "Besoin de projets ou de stockage supplémentaires, ou envie de changer de formule ?",
        "package_help_sup": "Besoin de projets, de places ou de stockage supplémentaires, ou envie de changer de formule ?",
        "plan_renamed": "Nous avons lancé de nouvelles formules, le nom affiché ici peut donc ne pas correspondre à votre abonnement actuel. Contactez-nous pour en savoir plus sur les nouvelles formules.",
        "projects": "Projets",
        "projects_available": "Tous les projets sont utilisés | 1 projet disponible | {count} projets disponibles",
        "seats": "Places",
        "seats_active": "/ {total} actives",
        "seats_package": "Aucune place dans votre forfait | 1 place dans votre forfait | {count} places dans votre forfait",
        "seats_paying": "+ 1 place payante supplémentaire | + {count} places payantes supplémentaires",
        "storage": "Stockage",
        "storage_available": "{amount} Go disponibles",
        "storage_total": "/ {amount} Go",
        "units": "Unités",
        "units_available": "Toutes les unités sont utilisées | 1 unité disponible | {count} unités disponibles"
      },
      "integrations": {
        "hide_details": "Masquer les détails",
        "last_synced_at": "Dernière synchronisation à: {time}",
        "show_details": "Afficher les détails"
      },
      "labels": {
        "all_projects": "Tous les projets",
        "confirmPasswordReset": "Un email est envoyé avec un lien pour réinitialiser votre mot de passe, veuillez vérifier votre boîte mail, contactez-nous si vous rencontrez des problèmes.",
        "disabled": {
          "access": "Nous accorderons à tous les employés l'accès à la plateforme à partir du moment où la dernière facture impayée est payée.",
          "contact": "Nous contacter",
          "overdue": "Nous avons remarqué que votre dernière facture est en retard depuis longtemps. Nous avons révoqué l'accès de tous les employés sur cette plateforme. Les partenaires et les clients pourront toujours accéder à leurs données.",
          "title": "Votre compte a été désactivé!"
        },
        "display": "Afficher",
        "filters": "Filtres",
        "generalNotifications": "Informez-moi des",
        "has_access_to": "A accès à",
        "information": "Informations sur le Profil",
        "informationNotificationsEmail": "Recevez une vue d'ensemble par courrier électronique, comprenant uniquement les notifications que vous n'avez pas encore vues sur la plate-forme.",
        "informationNotificationsPlatform": "Recevez toutes les notifications dans votre aperçu personnel situé en haut à droite de votre écran",
        "informationNotificationsTitle": "Décidez quelles notifications vous souhaitez recevoir et par quel canal",
        "its_you!": "C'est vous!",
        "maintainerAccess": "Accès accordé par projet.",
        "name": "Nom",
        "onPlatform": "Sur Plateforme",
        "ownerAccess": "Accès à tous les projets et contenus, plus la facturation et la gestion de l'équipe.",
        "password": "Mot de passe",
        "permissions": "Droits d'accès pour",
        "permissionsOwnerOnly": "En tant que Projet Mainteneur, vous ne pouvez pas effectuer cette action. Veuillez demander à un collègue de {client_name} ayant le rôle de Propriétaire de le faire pour vous",
        "projectMaintains": "{first_name} a accès aux projets suivants:",
        "projectMaintainsAdd": "Pour accorder l'accès, sélectionnez un projet et ajouter {first_name} en tant que responsable de projet sous la fonctionnalité Informations.",
        "projectMaintainsNone": "n'a accès à aucun projet.",
        "projectNotifications": "Pour le projet",
        "search_by_name_or_email": "Rechercher par nom ou e-mail",
        "show_signature": "Afficher la signature",
        "signature_active": "Signature active",
        "signature_info": "Cette signature sera ajoutée aux réponses envoyées aux clients et partenaires.",
        "sorting": "Tri",
        "viaEmail": "Par Email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accessible",
          "description": "Les modifications sont enregistrées automatiquement",
          "not_accessible": "Non accessible",
          "title": "Mettre à jour l'accessibilité du projet pour {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Mainteneur",
        "owner": "Propriétaire"
      },
      "team": {
        "actions": {
          "activate": "Activer",
          "cancel_invitation": "Annuler l'invitation",
          "deactivate": "Désactiver",
          "invite": "Inviter",
          "make_maintainer": "Rendre mainteneur",
          "make_owner": "Rendre propriétaire",
          "remove": "Retirer de l'équipe"
        },
        "dialogs": {
          "activate_body": "{name} retrouve un accès complet à la plateforme.",
          "activate_body_pending": "{name} repasse En attente et devient actif en se connectant avec son invitation.",
          "activate_body_seat": "{name} retrouve un accès complet à la plateforme. Cela utilise une place.",
          "activate_confirm": "Activer",
          "activate_title": "Activer {name} ?",
          "cancel_invitation_body": "{name} ne pourra plus rejoindre avec l'invitation reçue.",
          "cancel_invitation_confirm": "Annuler l'invitation",
          "cancel_invitation_title": "Annuler l'invitation ?",
          "contact_us": "Nous contacter",
          "contact_us_message": "Bonjour, je voudrais ajouter des places pour {client_name}.",
          "deactivate_body": "{name} garde son compte mais perd l'accès à la plateforme.",
          "deactivate_body_seat": "{name} garde son compte mais perd l'accès à la plateforme. Cela libère une place.",
          "deactivate_confirm": "Désactiver",
          "deactivate_title": "Désactiver {name} ?",
          "demote_body": "{name} perd l'accès à tous les projets jusqu'à ce que vous le lui donniez, et ne peut plus gérer la facturation ni l'équipe.",
          "demote_confirm": "Rendre mainteneur",
          "demote_title": "Rendre {name} mainteneur ?",
          "owner_wall_banner": "Votre organisation doit toujours avoir au moins un propriétaire actif.",
          "owner_wall_body_deactivate": "Réactivez ou promouvez un autre propriétaire avant de désactiver {name}.",
          "owner_wall_body_demote": "Réactivez ou promouvez un autre propriétaire avant de changer le rôle de {name}.",
          "owner_wall_body_remove": "Réactivez ou promouvez un autre propriétaire avant de retirer {name}.",
          "owner_wall_title": "Action bloquée",
          "promote_body": "{name} a accès à tous les projets et peut gérer la facturation et l'équipe.",
          "promote_confirm": "Rendre propriétaire",
          "promote_title": "Rendre {name} propriétaire ?",
          "remove_body": "{name} perd l'accès et quitte la liste des membres. Cette action est irréversible, mais vous pourrez l'inviter à nouveau plus tard.",
          "remove_body_seat": "{name} perd l'accès et quitte la liste des membres. Cette action est irréversible, mais vous pourrez l'inviter à nouveau plus tard. Cela libère une place.",
          "remove_confirm": "Retirer",
          "remove_title": "Retirer {name} de l'équipe ?",
          "seats_full_banner": "Votre seule place est utilisée. | Les {total} places sont toutes utilisées.",
          "seats_full_body": "Désactivez un membre actif pour libérer une place, ou contactez-nous pour ajouter des places.",
          "seats_full_invite_body": "Il vous faut une place disponible pour inviter quelqu'un. Désactivez un membre actif, ou contactez-nous pour ajouter des places.",
          "seats_full_invite_title": "Vous n'avez plus de places",
          "seats_full_title": "Aucune place disponible"
        },
        "invite_incomplete": "Remplissez le prénom, le nom et l'e-mail pour envoyer l'invitation.",
        "invite_note": "Ils deviennent actifs dès qu'ils créent un compte et se connectent.",
        "invite_note_seats": "Une fois leur compte créé et leur première connexion faite, ils deviennent actifs et utilisent votre dernière place disponible. | Une fois leur compte créé et leur première connexion faite, ils deviennent actifs et utilisent l'une de vos {count} places disponibles.",
        "invite_sent": "Invitation envoyée",
        "invited_at": "Invité : {when}",
        "last_active": "Dernière activité",
        "manage_in_billing": "Gérer dans Facturation",
        "resend_wait": "Vous pourrez renvoyer l'invitation 15 minutes après la précédente.",
        "role": "Rôle",
        "seat_states": "États des places",
        "seat_states_help": {
          "active": "Accès complet, utilise une place. Propriétaires et mainteneurs.",
          "inactive": "Le compte existe, pas d'accès à la plateforme. Libère la place.",
          "pending": "Invité, pas encore de compte. N'utilise pas de place."
        },
        "seat_usage": "Utilisation des places",
        "seats_available": "Aucune place disponible - désactivez un membre ou contactez-nous | 1 place disponible | {count} places disponibles",
        "seats_rule": "Seul un propriétaire peut activer un membre, et uniquement tant qu'une place est disponible.",
        "seats_total": "/ {total} place active | / {total} places actives",
        "statuses": {
          "active": "Actif",
          "inactive": "Inactif",
          "pending": "En attente"
        }
      },
      "toasts": {
        "create": "Collègue créé",
        "update": "Collègue modifié"
      },
      "validation": {
        "emailTaken": "L'adresse email a déjà été utilisée",
        "mustBeEmailAddress": "Adresse email valide requis",
        "needFirstName": "Prénom requis",
        "needLastName": "Nom requis",
        "requireEmailAddress": "Email requis",
        "role": "sélectionner les droits d'accès"
      }
    }
  }
}
